var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPos3Ico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.314,
    height: 42.551,
    viewBox: "0 0 33.314 42.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8932",
    "data-name": "Path 8932",
    d: "M272.312,906.037H268.28l-2.046,3.453-3.329,2.076-.153,3.971-2.122,3.512,2.122,3.512.153,3.971,3.329,2.078,2.046,3.451h4.031l3.574,2.017,3.573-2.017h4.031l2.046-3.451,3.331-2.078.152-3.971,2.123-3.512-2.123-3.512-.152-3.971-3.331-2.076-2.046-3.453h-4.031l-3.573-2.015Z",
    transform: "translate(-260.63 -904.022)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -4.906,
    y1: 11.793,
    x2: -4.887,
    y2: 11.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2755f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#f1705a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#ee5944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee5944"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8957",
    "data-name": "Path 8957",
    d: "M265.575,920.978a12.436,12.436,0,1,0,12.435-12.436,12.436,12.436,0,0,0-12.435,12.436",
    transform: "translate(-265.575 -908.542)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -6.132,
    y1: 14.146,
    x2: -6.109,
    y2: 14.146,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#ed6144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e34a2f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8958",
    "data-name": "Path 8958",
    d: "M267.926,921.979a11.085,11.085,0,1,0,11.085-11.085,11.085,11.085,0,0,0-11.085,11.085",
    transform: "translate(-267.926 -910.894)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -6.94,
    y1: 15.809,
    x2: -6.914,
    y2: 15.809,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fca771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#eb6c47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e45436"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_909",
    "data-name": "Rectangle 909",
    width: 64.319,
    height: 63.745,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8964",
    "data-name": "Path 8964",
    d: "M272.882,889.89a.409.409,0,0,0-.293.124l-.662.682a.408.408,0,0,0,.075.63l8.637,5.434.007-1.017V889.89Z",
    transform: "translate(-271.811 -889.89)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_912",
    "data-name": "Rectangle 912",
    width: 48.239,
    height: 45.942,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8967",
    "data-name": "Path 8967",
    d: "M287.2,889.89v5.852l.007,1.017,8.638-5.434a.408.408,0,0,0,.075-.63l-.662-.682a.408.408,0,0,0-.293-.124Z",
    transform: "translate(-287.195 -889.89)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_915",
    "data-name": "Rectangle 915",
    width: 47.665,
    height: 45.942,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8969",
    "data-name": "Path 8969",
    d: "M284.253,899.686A1.683,1.683,0,1,0,285.936,898a1.683,1.683,0,0,0-1.683,1.683",
    transform: "translate(-284.253 -898.003)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -48.507,
    y1: 106.368,
    x2: -48.337,
    y2: 106.368,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdc6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#fec041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb22a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_921",
    "data-name": "Rectangle 921",
    width: 3.365,
    height: 1.947,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6811",
    "data-name": "Group 6811",
    transform: "translate(-620.118 -659.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1768",
    "data-name": "Group 1768",
    transform: "translate(620.118 659.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1548",
    "data-name": "Group 1548",
    transform: "translate(1.401 11.117)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_904",
    "data-name": "Rectangle 904",
    width: 30.511,
    height: 30.055,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8933",
    "data-name": "Path 8933",
    d: "M258.19,930.188l2.318,3.835,1.206-.323-2.123-3.513Z",
    transform: "translate(-258.19 -904.044)",
    fill: "#dc4f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8934",
    "data-name": "Path 8934",
    d: "M262.226,936.627l.167,4.335,1.192-.687-.153-3.971Z",
    transform: "translate(-259.908 -906.648)",
    fill: "#ef624d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8935",
    "data-name": "Path 8935",
    d: "M262.516,943.906l1.192-.687,3.329,2.078-.887.877Z",
    transform: "translate(-260.032 -909.592)",
    fill: "#dc4f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8936",
    "data-name": "Path 8936",
    d: "M268.846,947.714l.887-.877,2.046,3.451-.7,1.2Z",
    transform: "translate(-262.727 -911.132)",
    fill: "#ef624d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8937",
    "data-name": "Path 8937",
    d: "M273.434,952.845h4.031l-.328,1.2h-4.4Z",
    transform: "translate(-264.383 -913.69)",
    fill: "#dc4f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8938",
    "data-name": "Path 8938",
    d: "M284.3,956.241v-1.379l-3.574-2.017-.328,1.2Z",
    transform: "translate(-267.646 -913.69)",
    fill: "#ef624d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8939",
    "data-name": "Path 8939",
    d: "M313.588,930.188l-2.318,3.835-1.206-.323,2.122-3.513Z",
    transform: "translate(-280.274 -904.044)",
    fill: "#dc4f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8940",
    "data-name": "Path 8940",
    d: "M311.157,936.627l-.167,4.335-1.192-.687.153-3.971Z",
    transform: "translate(-280.161 -906.648)",
    fill: "#ef624d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8941",
    "data-name": "Path 8941",
    d: "M308.522,943.906l-1.192-.687L304,945.3l.887.877Z",
    transform: "translate(-277.693 -909.592)",
    fill: "#dc4f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8942",
    "data-name": "Path 8942",
    d: "M303.371,947.714l-.887-.877-2.046,3.451.7,1.2Z",
    transform: "translate(-276.176 -911.132)",
    fill: "#ef624d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8943",
    "data-name": "Path 8943",
    d: "M297.45,952.845h-4.031l.328,1.2h4.4Z",
    transform: "translate(-273.188 -913.69)",
    fill: "#dc4f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8944",
    "data-name": "Path 8944",
    d: "M287.195,956.241v-1.379l3.574-2.017.328,1.2Z",
    transform: "translate(-270.538 -913.69)",
    fill: "#ef624d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8945",
    "data-name": "Path 8945",
    d: "M258.19,927.346l2.318-3.835,1.206.323-2.123,3.513Z",
    transform: "translate(-258.19 -901.202)",
    fill: "#ef624d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8946",
    "data-name": "Path 8946",
    d: "M262.226,920.3l.167-4.335,1.192.687-.153,3.971Z",
    transform: "translate(-259.908 -897.988)",
    fill: "#e85c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8947",
    "data-name": "Path 8947",
    d: "M262.516,914.281l1.192.687,3.329-2.078-.887-.877Z",
    transform: "translate(-260.032 -896.307)",
    fill: "#dc4f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8948",
    "data-name": "Path 8948",
    d: "M268.846,909.22l.887.878,2.046-3.451-.7-1.2Z",
    transform: "translate(-262.727 -893.513)",
    fill: "#dc4f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8949",
    "data-name": "Path 8949",
    d: "M273.434,906.647h4.031l-.328-1.2h-4.4Z",
    transform: "translate(-264.383 -893.514)",
    fill: "#ef624d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8950",
    "data-name": "Path 8950",
    d: "M284.3,901.62V903l-3.574,2.017-.328-1.2Z",
    transform: "translate(-267.646 -891.882)",
    fill: "#ef624d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8951",
    "data-name": "Path 8951",
    d: "M313.588,927.346l-2.318-3.835-1.206.323,2.122,3.513Z",
    transform: "translate(-280.274 -901.202)",
    fill: "#ef624d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8952",
    "data-name": "Path 8952",
    d: "M311.157,920.3l-.167-4.335-1.192.687.153,3.971Z",
    transform: "translate(-280.161 -897.988)",
    fill: "#e85c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8953",
    "data-name": "Path 8953",
    d: "M308.522,914.281l-1.192.687L304,912.891l.887-.877Z",
    transform: "translate(-277.693 -896.307)",
    fill: "#dc4f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8954",
    "data-name": "Path 8954",
    d: "M303.371,909.22l-.887.878-2.046-3.451.7-1.2Z",
    transform: "translate(-276.176 -893.513)",
    fill: "#dc4f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8955",
    "data-name": "Path 8955",
    d: "M297.45,906.647h-4.031l.328-1.2h4.4Z",
    transform: "translate(-273.188 -893.514)",
    fill: "#ef624d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8956",
    "data-name": "Path 8956",
    d: "M287.195,901.62V903l3.574,2.017.328-1.2Z",
    transform: "translate(-270.538 -891.882)",
    fill: "#ef624d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1552",
    "data-name": "Group 1552",
    transform: "translate(4.241 13.713)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_906",
    "data-name": "Rectangle 906",
    width: 24.871,
    height: 24.872,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1554",
    "data-name": "Group 1554",
    transform: "translate(5.591 15.064)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_907",
    "data-name": "Rectangle 907",
    width: 22.171,
    height: 22.17,
    transform: "translate(0)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1558",
    "data-name": "Group 1558",
    transform: "translate(5.591 15.064)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1557",
    "data-name": "Group 1557",
    transform: "translate(-21.12 -20.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1556",
    "data-name": "Group 1556",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_908",
    "data-name": "Rectangle 908",
    width: 64.319,
    height: 63.745,
    xlinkHref: "data:image/png;base64,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"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8960",
    "data-name": "Path 8960",
    d: "M290.8,886.364v1.359h-28v-1.359l1.7-1.7h24.6Z",
    transform: "translate(-260.156 -884.663)",
    fill: "#fff2b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8961",
    "data-name": "Path 8961",
    d: "M290.8,889.992V891.3l-1.7,1.768h-24.6l-1.7-1.768v-1.308Z",
    transform: "translate(-260.156 -886.932)",
    fill: "#dfa53f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8962",
    "data-name": "Path 8962",
    d: "M289.01,885.593H265.6l-1.618,1.4v2.2l1.618,1.46h23.41l1.618-1.46V887Z",
    transform: "translate(-260.656 -885.059)",
    fill: "#ffc835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8963",
    "data-name": "Path 8963",
    d: "M280.638,896.759,272,891.326a.409.409,0,0,1-.076-.631l.663-.682a.41.41,0,0,1,.293-.123h7.764v5.852Z",
    transform: "translate(-263.989 -886.889)",
    fill: "#ef5717"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1564",
    "data-name": "Group 1564",
    transform: "translate(7.822 3.001)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1563",
    "data-name": "Group 1563",
    transform: "translate(-18.183 -20.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1562",
    "data-name": "Group 1562",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_911",
    "data-name": "Rectangle 911",
    width: 48.239,
    height: 45.942,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFUAAABRCAYAAACjZOpMAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAVaADAAQAAAABAAAAUQAAAADb5qtJAAAEzElEQVR4Ae3azW4bVRQH8HPuHXvs8VfsFOJEXVAhsWBRJJQNO9ZdsucdeAIQPEGfhBVixQIhUDcV6gJQVSGlEimkhdruOBl7PHPP5YzlrBDoXtEr30hnotHk4+h48sv/fkxktNaCHK9XQL3edtKtERDUADkQVEENIBCgpSRVUAMIBGgpSRXUAAIBWkpSBTWAQICWklRBDSAQoKUkVVADCARoKUkV1AACAVpKUgU1gECAlpJUQQ0gEKClJFVQAwgEaClJFdQAAgFaSlIFNYBAgJaSVEENIBCgpSRVUAMIBGgpSQ2AmgTo+b9a/o7H+G8NTuwfN+LNtBjLm34bzMmnOZZnKZq5xu9/6MPwPdoC3+0Xdv1V0oBuz9hxo0BtQHsfl+rnX/t6lJpkWWiddqxGY7eo9QqpnxpztdL18kCZd77dmAY4Vty9o+6GO158pFs2x3S9pEwTdLGFqUab2Jr1FDS8ZW2g6HbVyi6gvHN7XWfvF9T5pLAwjus99lGgPrrX0XfyTTqrYNBuwaGtYMKQQ2UZF0GTxRrBXvKqOme+GRn1atCh4nmSbGJMbRQLVVYQXhUq0Zq6poaDRMEJAUx5iI+JYS3YZnLNK4TnGuCZbdmLS7Ivh0DL89NkffthXXHiIZbpIArUZrXHCcvlSG0F1hAopWyXl6VDRp0ohJRXqFIRHDXQXDJEVOfVhi7amZo//aBl33pQ8USxXciadns9okDlIUwv3tVVfWBXLYIFI/Y5qX0e6gONMOTriJWGwJ/zdcSpHRmyGX9fs7RNe4qefNheAR5HsXjtHbUZsuvPevbJd7fqaVkVLy3O2hxc/uC8gkHLixRfOYNv8NnlBavZyLYZVCnAmk1XWMBqUNCGwbe7gr3GlF88iieqZgVvFpyLtFUO5pj3UnihDTxNEB/zsP+Jz18Y+YyvMz4tp3jIaT7iuXbKiuMKKOt1TfLNmz3c7Sb26rr3pG5/e94SncwQJvczU/yY2bPzDukhVKYyJQeyYMWcLXMGzbWFqUHo8bTAGwJM+eElJYNJTkrdOuWffL1Xz+2Lx4Ha3ArDdj4HO+N58Rhq4sWHxhqrK8BSVXSFCpcEdsHD/i+uPuTFDHnBWvJQq7C2RAlvwCI54kHdgWy3RfNtamtOLXFqjRqqDad2zZPsJSg74wfWQx72KWe1+XqBHShHytDZoB0F7N43//8VruunLU5tMtamdaVVZioa8LAfJDzsDeDGKvsqRVzQERTTL03FfxSecvd7RI26pZkjru9nyKlVv9k0qUts23WdbjYqIQXUa6uSclgfP6orrqcYHgDiR92F7jq1D8cdNX271tmYVPmnsmUXiTf+zVYqCtDmdqObU3eG/7jsEmhPeSGb3Mtp9kXzHEDA/y6E2YNhFJv+65u+MUm9vuGbcI1i838ToHzuUVB9tBxrBdURyqdMUH20HGsF1RHKp0xQfbQcawXVEcqnTFB9tBxrBdURyqdMUH20HGsF1RHKp0xQfbQcawXVEcqnTFB9tBxrBdURyqdMUH20HGsF1RHKp0xQfbQcawXVEcqnTFB9tBxrBdURyqdMUH20HGsF1RHKp0xQfbQcawXVEcqnTFB9tBxrBdURyqdMUH20HGsF1RHKp0xQfbQcawXVEcqn7G9bkuMGN/8JEAAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8965",
    "data-name": "Path 8965",
    d: "M276.351,889.89l6.227,4.1v-1.8l-3.583-2.3Z",
    transform: "translate(-265.922 -886.888)",
    fill: "#fed2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8966",
    "data-name": "Path 8966",
    d: "M287.2,896.759l8.637-5.434a.409.409,0,0,0,.076-.631l-.663-.682a.41.41,0,0,0-.293-.123H287.2v5.852Z",
    transform: "translate(-270.538 -886.889)",
    fill: "#eb3f1b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1570",
    "data-name": "Group 1570",
    transform: "translate(16.657 3.001)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1569",
    "data-name": "Group 1569",
    transform: "translate(-20.7 -20.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1568",
    "data-name": "Group 1568",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_914",
    "data-name": "Rectangle 914",
    width: 47.665,
    height: 45.942,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABRCAYAAABMpoFyAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAVKADAAQAAAABAAAAUQAAAABcQGAKAAAEoElEQVR4Ae3bz28bRRQH8Pdm1r/WaX45pDSNoEFtJBSJQ1UOiAsXbvxNIPEX8D9w54I4waEHJC6l6gFxQEIFEmj6w47txOtd78483sStVA6o7zCSJ9JbKd6N/fQy+fi7O2PLRiIC3eIJmHittFMQUNDIOVBQBY0sELmdJlRBIwtEbqcJVdDIApHbaUIVNLJA5HaaUAWNLBC5nSZUQSMLRG6nCVXQyAKR22lCFTSyQOR2mlAFjSwQuZ0mVEEjC0RupwlV0MgCkdtpQhU0skDkdppQBY0sELmdJlRBIwtEbqcJjQyaRe4Xvd0/eAP/r+kePUnuw62Y6gduX0IGzMuf3z5pX8Ie3l9Q97MG7JajzkFFoy/XKSXY5EBfQTKgvTb2tjf2WbFtbNYjQ1MEb4HW2s41ObpJZZuj2xdu9nXHp4KaDugZYvlVjsXD3Dw+6WZkoDNvfK/VghwBO4bIhlPfOGgWHqsGad5pm4LvqvYfNDXvk0hqEtfQZSrfxpDKnWPX7m76vPCw0TOw7RrYsobWvMfMIDlCmLcsTK3BUbXwsDVD92Cr6+6dlS6Ar3pLApQR8I+PWll+4bsXbbpm5zCgLtzgu29aouvkYd0YPuU9zPmKesbfszjFGnwGWJQbOM9PabFqyFd/f+XLppBOTpgZuKaDzm3YLu5BBneohiMg+oATecSIdxhznwc9QIQe703WIvIG/Do6yj5MZ7JPIaF4890mcwvMyeKOcXTAUIeG4BYz7SJBl0EXBDgDpKlBGPJ+uFjgeLNN82Ju6sOf+dxPZFtpQkM6f9jtY5jJS0c5ehiwyz4jvsOI1/m4x/uKCJ/x9fNPRPy99vAYDP6dZTiyHSr2dxfN9ufTJCak8JyuPKE79xye/2KNNa7Na+IcCNY4jR1efjQhjZ7gKSfymMf6Fzk4sRae5UgTV8DsdLNVr98n1/2mSOacXzloeFbtDl8peY7mpRKhg4rTOAaPEzB0xqfQCaMe86r+FK0fGrLnPJ+XB4dlc3i38JeYW+l8HTAJ0P4L7ydvQd0GOHeATzmpBSJVbD20Hp4w9POugQlNzGy6i/Wtn+qmfJTR9rezZJIZghG2lYN+PJjQyXs9V4+gyCwMyRPyEp7XnDjnxdDYd/zYentRek7l+2VzO6TyOz7FE0rlknJ5u/JXSuUXffPw+0GW1dStK99vZ9BfDo2qdmmK9oDKM2cvU8n3JzP5vI74+vFKZ/kwkPDmRng9zofVYI3Oef3+AtE8703NqOrjxcaPvrz76bDZG50mjxn+n5UnNAxi+dKTF0i8YP+138GwUOd3lcLaMlwjrwQkj/NySwI0jOQl6nJUL29TeQfpP4N6wy/JgL5hnFfm4ZVfQ6+MlHCgCiqEkpYpqFRKWKegQihpmYJKpYR1CiqEkpYpqFRKWKegQihpmYJKpYR1CiqEkpYpqFRKWKegQihpmYJKpYR1CiqEkpYpqFRKWKegQihpmYJKpYR1CiqEkpYpqFRKWKegQihpmYJKpYR1CiqEkpYpqFRKWKegQihpmYJKpYR1CiqEkpYpqFRKWKegQihpmYJKpYR1CiqEkpYpqFRKWPcv7HGzg5bZm34AAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8968",
    "data-name": "Path 8968",
    d: "M293.423,889.89l-6.227,4.1v-1.8l3.583-2.3Z",
    transform: "translate(-270.538 -886.888)",
    fill: "#fed2bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1579",
    "data-name": "Group 1579",
    transform: "translate(14.967 7.661)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_920",
    "data-name": "Rectangle 920",
    width: 3.365,
    height: 3.365,
    transform: "translate(0)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1583",
    "data-name": "Group 1583",
    transform: "translate(14.968 7.66)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1582",
    "data-name": "Group 1582",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1581",
    "data-name": "Group 1581",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8970",
    "data-name": "Path 8970",
    d: "M287.619,899.685a1.607,1.607,0,0,1-.021.264,1.682,1.682,0,0,0-3.322,0,1.607,1.607,0,0,1-.021-.264,1.682,1.682,0,1,1,3.365,0",
    transform: "translate(-284.254 -898.002)",
    fill: "#fce689"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8975",
    "data-name": "Path 8975",
    d: "M288.747,928.365a5.29,5.29,0,0,1-.415,2.1,4.389,4.389,0,0,1-1.764,2.127,5.258,5.258,0,0,1-2.884.778,5.184,5.184,0,0,1-2.864-.8,4.575,4.575,0,0,1-1.8-2.168,5.856,5.856,0,0,1-.395-1.826.22.22,0,0,1,.249-.249h2.988a.242.242,0,0,1,.27.249,3.094,3.094,0,0,0,.249,1,1.317,1.317,0,0,0,.5.633,1.5,1.5,0,0,0,2.1-.571,2.8,2.8,0,0,0,.291-1.37,3.405,3.405,0,0,0-.291-1.452,1.43,1.43,0,0,0-1.328-.768,1.063,1.063,0,0,0-.508.156,8.06,8.06,0,0,0-.716.467.355.355,0,0,1-.166.063.2.2,0,0,1-.187-.125l-1.473-2.075a.359.359,0,0,1-.063-.167.2.2,0,0,1,.1-.187l3.2-2.427a.087.087,0,0,0,.031-.083c-.007-.028-.031-.041-.073-.041h-4.544a.248.248,0,0,1-.249-.249v-2.448a.247.247,0,0,1,.249-.249h9.047a.248.248,0,0,1,.249.249v2.759a.394.394,0,0,1-.145.311l-2.511,1.971a.085.085,0,0,0-.032.083c.007.028.032.049.073.063a3.531,3.531,0,0,1,2.407,2.116,5.5,5.5,0,0,1,.415,2.137",
    transform: "translate(-266.888 -899.143)",
    fill: "#d8564d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8976",
    "data-name": "Path 8976",
    d: "M288.747,928.365a5.29,5.29,0,0,1-.415,2.1,4.389,4.389,0,0,1-1.764,2.127,5.258,5.258,0,0,1-2.884.778,5.184,5.184,0,0,1-2.864-.8,4.575,4.575,0,0,1-1.8-2.168,5.856,5.856,0,0,1-.395-1.826.22.22,0,0,1,.249-.249h2.988a.242.242,0,0,1,.27.249,3.094,3.094,0,0,0,.249,1,1.317,1.317,0,0,0,.5.633,1.5,1.5,0,0,0,2.1-.571,2.8,2.8,0,0,0,.291-1.37,3.405,3.405,0,0,0-.291-1.452,1.43,1.43,0,0,0-1.328-.768,1.063,1.063,0,0,0-.508.156,8.06,8.06,0,0,0-.716.467.355.355,0,0,1-.166.063.2.2,0,0,1-.187-.125l-1.473-2.075a.359.359,0,0,1-.063-.167.2.2,0,0,1,.1-.187l3.2-2.427a.087.087,0,0,0,.031-.083c-.007-.028-.031-.041-.073-.041h-4.544a.248.248,0,0,1-.249-.249v-2.448a.247.247,0,0,1,.249-.249h9.047a.248.248,0,0,1,.249.249v2.759a.394.394,0,0,1-.145.311l-2.511,1.971a.085.085,0,0,0-.032.083c.007.028.032.049.073.063a3.531,3.531,0,0,1,2.407,2.116,5.5,5.5,0,0,1,.415,2.137",
    transform: "translate(-266.888 -899.143)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPos3Ico);
export default __webpack_public_path__ + "static/media/pos3-ico.1328cbf1e93e85b16c6506b5a74dc380.svg";
export { ForwardRef as ReactComponent };